import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Popconfirm, Tooltip } from "antd";
import { faAngleLeft, faArrowRightLong, faXmark } from "@fortawesome/free-solid-svg-icons";

//STYLES
import { BodyDrawer, CloseTopDrawer, DrawerCustomWrapper, FooterDrawer, HeaderDrawer } from "./style";

//COMPONENTS
import ButtonCustom from "../../ButtonCustom";
import { Inline } from "../inline";
import { Render } from "../render";
import { TitleH1 } from "../titleH1";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/pt-br";

dayjs.extend(relativeTime);
dayjs.locale("pt-br");
// import { ConfirmarFecharGaveta } from "../../../Views/app/patrimonioNovo/components/confirmarFecharGaveta";

//interface
interface Props {
    open: boolean;
    onClose: Function;
    children?: React.ReactNode;
    childrenFooter?: React.ReactNode;
    destroyOnClose?: boolean;
    width?: number | string;
    closeButtonLabel?: 'Fechar' | 'Voltar';
    title?: string;
    actions?: React.ReactNode;
    paddingBody?: number;
    extraHeader?: React.ReactNode;
    confirmOnClose?: boolean;
    setConfirmOnClose?: React.Dispatch<React.SetStateAction<boolean>>;
    createdBy?: string;
    createdAt?: string;
    updatedBy?: string;
    updatedAt?: string;
    overflow?: string;
    title_confirm?: string;
}

export const DrawerCustom: React.FC<Props> = ({ open, onClose, children, width, closeButtonLabel = 'Fechar',
    title, actions, paddingBody, childrenFooter, extraHeader, confirmOnClose, title_confirm, createdAt, updatedAt, createdBy, updatedBy, overflow
}) => {

    //STATES
    const [open_confirm, setOpen_confirm] = useState<boolean>(false);

    function fecharGaveta() {
        if (confirmOnClose) {
            setOpen_confirm(true);
        } else {
            onClose();
        }
    }

    return (
        <DrawerCustomWrapper
            open={open}
            onClose={() => { fecharGaveta() }}
            destroyOnClose
            headerStyle={{ display: 'none' }}
            footer={false}
            width={width ?? 500}
            bodyStyle={{ padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
        >

            <CloseTopDrawer>


                <Popconfirm
                    placement='left'
                    title={title_confirm ?? 'Você não salvou o cadastro!'}
                    open={open_confirm}
                    description={
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                            <span>
                                {'Deseja fechar sem salvar? Todas as informações inseridas serão perdidas.'}
                            </span>
                            <Inline justifyContent='flex-end'>
                                <ButtonCustom
                                    onClick={() => {
                                        // usuário já confirmou: fecha direto, sem reabrir o confirm
                                        setOpen_confirm(false);
                                        onClose();
                                    }}
                                    icon={<FontAwesomeIcon icon={faXmark} />}
                                    danger
                                    type='tertiary'
                                >
                                    Fechar
                                </ButtonCustom>

                                <ButtonCustom
                                    onClick={() => {
                                        setOpen_confirm(false)
                                    }}
                                    // type="tertiary"
                                    icon={<FontAwesomeIcon icon={faArrowRightLong} />}
                                >
                                    Voltar para o cadastro
                                </ButtonCustom>
                            </Inline>
                        </div>
                    }
                    okButtonProps={{ style: { display: 'none' } }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <Button style={{ background: 'transparent', padding: 0, margin: 0, border: 'none', boxShadow: 'none', all: 'unset' }}>
                        <ButtonCustom
                            // onClick={()=>{setOpen_confirm(true)}}
                            onClick={() => { fecharGaveta() }}
                            type="tertiary"
                            icon={<FontAwesomeIcon icon={closeButtonLabel === 'Fechar' ? faXmark : faAngleLeft} />}
                            danger
                        >
                            Fechar
                        </ButtonCustom>
                    </Button>
                </Popconfirm>

                {actions}
            </CloseTopDrawer>

            <Render condition={!!title}>
                <HeaderDrawer>
                    <div className="HeaderDrawer__info">
                        <TitleH1>{title}</TitleH1>
                        <Render condition={!!createdBy && !!createdAt}>
                            {(updatedBy === null || updatedBy === '')
                                ? <Tooltip title="Ainda não foi editado"><span style={{ color: 'var(--primary-color)' }}>Criado por: {createdBy} em {dayjs(createdAt).format('DD/MM/YYYY [às] HH[h]mm')} <b>({dayjs(createdAt).fromNow()} atrás)</b></span></Tooltip>
                                : <Tooltip color="green" title={`E criado por: ${createdBy} em ${dayjs(createdAt).format('DD/MM/YYYY [às] HH[h]mm')}`}><span>Última edição: {updatedBy} em {dayjs(updatedAt).format('DD/MM/YYYY [às] HH[h]mm')} <b>({dayjs(updatedAt).fromNow()} atrás)</b></span></Tooltip>
                            }
                        </Render>
                    </div>
                    {extraHeader}
                </HeaderDrawer>
            </Render>

            <BodyDrawer style={{ padding: paddingBody }} overflow={overflow}>
                {children}
            </BodyDrawer>

            {childrenFooter && (
                <FooterDrawer style={{ padding: paddingBody }}>
                    {childrenFooter}
                </FooterDrawer>
            )}


        </DrawerCustomWrapper>
    )
}